<template>
  <nav class="sidebar-nav">
    <VuePerfectScrollbar class="scroll-area" :settings="psSettings" @ps-scroll-y="scrollHandle">
      <ul class="nav">
        <template v-for="(item, index) in navItems">
          <template v-if="item.title">
           <SidebarNavTitle :key="index" :name="item.name" :classes="item.class" :wrapper="item.wrapper"/>
          </template>
          <template v-else-if="item.divider">
            <SidebarNavDivider :key="index" :classes="item.class"/>
          </template>
          <template v-else-if="item.label">
            <SidebarNavLabel :key="index" :name="item.name" :url="item.url" :icon="item.icon" :label="item.label" :classes="item.class"/>
          </template>
          <template v-else>
            <template v-if="item.children && canSeeMenu(item)">
              <!-- First level dropdown -->
              <SidebarNavDropdown :key="index" :name="item.name" :url="item.url" :icon="item.icon">
                <template v-for="(childL1, index1) in item.children">
                  <template v-if="childL1.children">
                    <!-- Second level dropdown -->
                    <SidebarNavDropdown :key="index1" :name="childL1.name" :url="childL1.url" :icon="childL1.icon" v-if="childL1">
                      <li :key="index2" class="nav-item" v-for="(childL2, index2) in childL1.children">
                        <HollyFiSideBarNavLink :name="childL2.name" :url="childL2.url" :icon="childL2.icon" :badge="childL2.badge" :variant="item.variant"/>
                      </li>
                    </SidebarNavDropdown>
                  </template>
                  <template v-else>
                    <SidebarNavItem :key="index1" :classes="item.class" v-if="canSeeMenu(childL1)">
                      <HollyFiSideBarNavLink :name="childL1.name" :url="childL1.url" :icon="childL1.icon" :badge="childL1.badge" :variant="item.variant"/>
                    </SidebarNavItem>
                  </template>
                </template>
              </SidebarNavDropdown>
            </template>
            <template v-else>
              <SidebarNavItem :key="index" :classes="item.class" v-if="canSeeMenu(item)">
                <HollyFiSideBarNavLink :name="item.name" :url="item.url" :icon="item.icon" :badge="item.badge" :badgeState1="item.badgeState1" :badgeState2="item.badgeState2" :variant="item.variant"/>
              </SidebarNavItem>
            </template>
          </template>
        </template>
      </ul>
      <slot></slot>
    </VuePerfectScrollbar>
  </nav>
</template>

<script>
import { SidebarNavDivider } from '@coreui/vue'
import {SidebarNavDropdown} from '@coreui/vue'
import HollyFiSideBarNavLink from './HollyFiSideBarNavLink'
import {SidebarNavTitle} from '@coreui/vue'
import {SidebarNavItem} from '@coreui/vue'
import {SidebarNavLabel} from '@coreui/vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
export default {
  name: 'HollyFiSideBar',
  props: {
    navItems: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  components: {
    SidebarNavDivider,
    SidebarNavDropdown,
    HollyFiSideBarNavLink,
    SidebarNavTitle,
    SidebarNavItem,
    SidebarNavLabel,
    VuePerfectScrollbar
  },
  data () {
    return {}
  },
  computed: {
    psSettings: () => {
      // ToDo: find better rtl fix
      return {
        maxScrollbarLength: 200,
        minScrollbarLength: 40,
        suppressScrollX: getComputedStyle(document.querySelector('html')).direction !== 'rtl',
        wheelPropagation: false,
        interceptRailY: styles => ({ ...styles, height: 0 })
      }
    },
    isUser () {
      return this.$store.getters.isUser;
    },
    isAdmin () {
      return this.$store.getters.isAdmin;
    },
    isSuperAdmin () {
      return this.$store.getters.isSuperAdmin;
    }
  },
  methods: {
    scrollHandle (evt) {
      // console.log(evt)
    },
    showAdminMenu (adminOnly) {
      return !adminOnly || (adminOnly && this.isAdmin);
    },
    canSeeMenu (childL1) {
      return (childL1.superAdmin && this.isSuperAdmin) || (childL1.admin && this.isAdmin) || (childL1.user && this.isUser);
    }
  }
}
</script>

<style scoped lang="css">
  .scroll-area {
    position: absolute;
    height: 100%;
    margin: auto;
  }
</style>